export default {
  GET_TRACE_FILTER: 'GET_TRACE_FILTER',
  GET_TRACE_FILTER_SUCCESS: 'GET_TRACE_FILTER_SUCCESS',
  GET_TRACE_FILTER_ERROR: 'GET_TRACE_FILTER_ERROR',
  TRACE_FILTER_PAYLOAD: 'TRACE_FILTER_PAYLOAD',
  TRACE_FILTER_APPLY: 'TRACE_FILTER_APPLY',
  TRACE_INITIAL_FILTERS: 'TRACE_INITIAL_FILTERS',
  TRACE_FILTER_MIN_DATE_FROM: 'TRACE_FILTER_MIN_DATE_FROM',
  TRACE_FILTER_MAX_DATE_TO: 'TRACE_FILTER_MAX_DATE_TO',
};
